import { isTicketActionType } from "@/pages/GovernancePage/helpers/workflows"
import { TicketIssueActionForm } from "./TicketIssueActionForm"

import type { TicketIssueActionProps } from "./TicketIssueAction.types"

// One action component for every non-Jira ticketing vendor, picked by the action type
export const TicketIssueAction = (props: TicketIssueActionProps) => {
  const { params, actions: _actions, ...rest } = props
  const { action_type: actionType, trigger_type: triggerType = "" } = params

  if (!isTicketActionType(actionType)) return null

  return (
    <TicketIssueActionForm
      actionType={actionType}
      triggerType={triggerType}
      {...rest}
    />
  )
}
